import { HOT_LIST } from '@/mocks/celebrity';

export default function Trending() {
  return (
    <section id="hot" className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-accent-600">HOT LIST</p>
          <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            今天在磕什么·吃瓜热搜榜
          </h2>
        </div>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-700">
          <i className="ri-refresh-line text-sm text-accent-600" />
          每分钟实时刷新
        </span>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
        {HOT_LIST.map((item, i) => (
          <a
            key={item.rank}
            href="#feeds"
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200 hover:bg-primary-100/40 md:gap-4 md:p-4"
          >
            <span
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                i < 3 ? 'bg-accent-500 text-foreground-950' : 'bg-secondary-100 text-secondary-700'
              }`}
            >
              {item.rank}
            </span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700 md:text-[15px]">
                {item.title}
              </p>
              <span className="mt-1 inline-flex items-center gap-2 text-xs text-foreground-500">
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-700">
                  #{item.tag === 'love' ? '恋情公开' : item.tag === 'dating' ? '约会实锤' : item.tag === 'breakup' ? '分手复合' : '感情线盘点'}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-fire-fill text-accent-600" />
                  {item.heat}
                </span>
              </span>
            </div>
            <i className="ri-arrow-right-up-line text-lg text-foreground-300 transition-colors group-hover:text-primary-600" />
          </a>
        ))}
      </div>
    </section>
  );
}